import { c as create_ssr_component, b as add_attribute } from "./ssr.js";
import { c as classNames } from "./util.js";
const NotEditable = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { editable } = $$props;
  if ($$props.editable === void 0 && $$bindings.editable && editable !== void 0)
    $$bindings.editable(editable);
  return `<div${add_attribute("class", classNames(editable ? "opacity-25 cursor-not-allowed relative" : ""), 0)}>${editable ? `<div class="absolute inset-0 z-50"></div>` : ``} ${slots.default ? slots.default({}) : ``}</div>`;
});
export {
  NotEditable as N
};
